/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowServiceCatalog {
    getFixupPrototypeFunction() { return ServiceNowServiceCatalog.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowServiceCatalog>): ServiceNowServiceCatalog {
        let obj = Object.assign(new ServiceNowServiceCatalog(), model);
        ServiceNowServiceCatalog.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowServiceCatalog>): ServiceNowServiceCatalog {
        if (!model) return null;
        return ServiceNowServiceCatalog.newInstance(<ServiceNowServiceCatalog> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowServiceCatalog) {
        if (!obj) return;

        models.ServiceNowServiceCatalog.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowServiceCatalog): boolean {
        Object.setPrototypeOf(obj, ServiceNowServiceCatalog.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.catalog) {
            models.ServiceNowRequestComponent.fixupPrototype(this.catalog);
        }
        if (this.categories) {
            for (let val of this.categories) {
                models.ServiceNowServiceCatalogCategory.fixupPrototype(val);
            }
        }
    }

    catalog: models.ServiceNowRequestComponent;

    /**
     * List of Service Catalog Categories
     */
    categories: Array<models.ServiceNowServiceCatalogCategory>;

}
